<template>
  <div class="modal article" :class="{ active: showModal }">
    <div class="container modal-top" @click="$emit('modal', 'article')">
      <div class="modal-top__back-Link">
        <BackIcon />
      </div>
      <div class="modal-top__wrap">
        <div class="modal-top__title">Назад</div>
      </div>
    </div>
    <div class="container article-container" v-cloak>
      <div v-if="article">
        <div class="article__title">{{ article.title }}</div>
        <div class="article__info">
          <div
            class="article__autor"
            @click="
              () => {
                searchByAuthor(article?.author);
              }
            "
          >
            <div
              v-if="article?.author?.poster_url"
              class="article__autor_image"
            >
              <img :src="article.author.poster_url" alt="" />
            </div>
            <div v-if="article?.author?.name" class="article__autor_name">
              {{ article.author.name }}
            </div>
          </div>
          <router-link
            v-if="article?.category?.name"
            :to="`/category/${article.category.id}`"
            class="article__category"
            @click="$emit('modal', 'article')"
          >
            {{ article.category.name }}
          </router-link>
        </div>
        <div
          v-if="article.files.length > 0 && showModal"
          class="article__files"
        >
          <div v-if="article.files.length < 2" class="article__file">
            <MediaBlock :media="article.files[0]" />
          </div>
          <div v-if="article.files.length > 1" class="article__file">
            <swiper
              :slides-per-view="1"
              :space-between="8"
              @swiper="onSwiper"
              @slideChange="onSlideChange"
            >
              <swiper-slide
                v-for="file in article.files"
                :key="file.id"
                class="article__files_item"
              >
                <MediaBlock :media="file" />
              </swiper-slide>
            </swiper>
          </div>
        </div>
        <TextWithLinks
          class="article__text"
          :text="article.description"
          @openArticle="(id) => $emit('openArticle', id)"
        ></TextWithLinks>
        <div
          class="article__likes"
          :class="{ active: article.is_liked_by_auth_user }"
        >
          <div
            class="article__likes_icon"
            @click="doLike(article.is_liked_by_auth_user ? false : true)"
          >
            <HeartIcon />
          </div>
          <div class="article__likes_count">{{ article.likes_count }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BackIcon from '@/components/icons/BackIcon.vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import HeartIcon from '@/components/icons/HeartIcon.vue';
import { getArticle, like, unlike } from '@/functions/API';
import MediaBlock from '@/components/blocks/media/MediaBlock.vue';
import TextWithLinks from '@/components/blocks/link/TextWithLinks.vue';

export default {
  name: 'ArticleModal',
  components: {
    BackIcon,
    Swiper,
    SwiperSlide,
    HeartIcon,
    MediaBlock,
    TextWithLinks,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    articleId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      article: null,
      showModal: false,
    };
  },
  setup() {
    const onSwiper = (swiper) => {
      console.log(swiper);
    };
    const onSlideChange = () => {
      console.log('slide change');
    };
    return {
      onSwiper,
      onSlideChange,
    };
  },
  mounted() {
    this.showModal = this.show;
  },
  watch: {
    show() {
      this.showModal = this.show;
      if (this.show && this.articleId) {
        this.getPage(this.articleId);
      }
    },
    articleId() {
      this.showModal = this.show;
      if (this.show && this.articleId) {
        this.getPage(this.articleId);
      }
    },
  },
  methods: {
    getPage(id) {
      getArticle(id, (res) => {
        if (res !== false) {
          this.article = res;
        }
      });
    },
    doLike(target) {
      if (target) {
        like(this.articleId, (res) => {
          if (res !== false) {
            this.getPage(this.articleId);
          }
        });
      } else {
        unlike(this.articleId, (res) => {
          if (res !== false) {
            this.getPage(this.articleId);
          }
        });
      }
    },
    searchByAuthor(author) {
      this.$emit('modal', 'article');
      this.$router.push({
        name: 'lib',
        query: { author_name: author.name, author_id: author.id },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.modal {
  width: 100%;
  height: 100vh;
  &-top {
    position: relative;
    background-color: var(--color-white);
    color: var(--color-black);
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 12px;
    position: relative;
    display: flex;
    padding-top: 16px;
    padding-bottom: 16px;
    cursor: pointer;
    &__wrap {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      min-height: 40px;
    }
    &__back-Link {
      color: var(--color-blue);
      svg {
        width: 20px;
        height: 20px;
        min-width: 20px;
        min-height: 20px;
      }
    }
    &__title {
      color: var(--color-black);
      text-align: center;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 125%;
    }
  }
}
.article {
  position: fixed;
  left: 0;
  top: -120%;
  height: 100%;
  width: 100%;
  background-color: var(--color-white);
  transition: 0.3s ease-in-out;
  &.active {
    top: 0;
  }
  &-container {
    display: flex;
    flex-direction: column;
    gap: 32px;
    overflow-y: auto;
    max-height: calc(100vh - 72px);
  }
  &__title {
    color: var(--color-black);
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 133%;
    margin-top: 16px;
    margin-bottom: 16px;
  }
  &__info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 16px;
    margin-bottom: 16px;
  }
  &__autor {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    &_image {
      img {
        width: 32px;
        height: 32px;
        min-width: 32px;
        min-height: 32px;
        object-fit: cover;
        border-radius: 50%;
      }
    }
    &_name {
      color: var(--color-gray);
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 125%;
    }
  }
  &__category {
    color: var(--color-gray);
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 125%;
    background-color: var(--color-gray-light);
    border-radius: 30px;
    padding: 6px 10px;
    text-align: center;
  }
  &__files {
    overflow: hidden;
    .swiper {
      overflow: visible;
      max-width: 80%;
      margin-left: 0;
    }
  }
  &__file {
    width: 100%;
    height: 220px;
    position: relative;
  }
  &__text {
    color: var(--color-black);
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
    margin-top: 32px;
    margin-bottom: 32px;
  }
  &__likes {
    display: flex;
    align-items: center;
    gap: 6px;
    &_icon {
      width: 34px;
      height: 34px;
      background-color: var(--color-gray-light);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      color: var(--color-blue);
      svg {
        width: 20px;
        height: 20px;
        min-width: 20px;
        min-height: 20px;
      }
    }
    &_count {
      color: var(--color-gray);
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 125%;
    }
    &.active {
      .article__likes_icon {
        background-color: var(--color-blue);
        color: var(--color-white);
      }
      .article__likes_count {
        color: var(--color-blue);
      }
    }
  }
}
</style>
